import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=1c3a4f1d&scoped=true&"
import script from "./OrderItem.vue?vue&type=script&lang=js&"
export * from "./OrderItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=1c3a4f1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a4f1d",
  null
  
)

export default component.exports